/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react'
import { Container } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import ReactSwitch from 'react-switch'
import { useSelector } from 'react-redux'

import './styles.scss'
import { BrandsAndDelegations, SelectWithLabel } from '../../Form'
import { categories as categoriesApi } from 'api'
import CategoriesList from './CategoriesList'
import CategoriesDetail from './CategoriesDetail'
import ModalDelete from 'components/ModalDelete'
import { getStaticImage } from 'utils/statics'

const _ = require('lodash')

const _headers = [
  { label: 'dashboard_label', value: 'category-name', filter: 'asc' },
  { label: 'dashboard_brand', value: 'brand', filter: null },
  { label: 'dashboard_delegation', value: 'delegation', filter: null },
]

function getObjectValues(objValues, selectedValues, isOperators) {
  return Object.values(objValues).map((item) => ({
    value: item._id,
    label: !isOperators ? item.name : `${item.name} ${item.lastname || ''}`,
    data: item,
    disabled: item._id === 'all' ? false : selectedValues && selectedValues.some(v => v.value === 'all')
  }))
}

function getRightName(text) {
  if (['all', 'some'].includes(text)) return I18n.t(`dashboard_${text}-plural-female`)

  return text
}

function orderItems(external, asigned) {
  let result = external
    .reduce((preV, next) => {
      const item = asigned.find(el => el._id === next.value)
      preV.push({
        value: item ? item._id : next._id || next.value,
        label: item ? item.name : getRightName(next.name) || next.label,
        data: item ? (item.data || item) : next.data || next || {},
        isFixed: true,
      })
      return preV
    }, [])
    .sort((a, b) => (a.isFixed === b.isFixed ? 0 : a.isFixed ? -1 : 1))
    .sort((a, b) => a.label - b.label)


  result.forEach(re => {
    asigned.forEach(as => {
      if (re.value === as._id) {
        re.isFixed = false
      }
    })
  })

  //REMOVE ITEMS IF ALL ES SELECTED
  if (result.some(it => it.value === 'all')) {
    return result.filter(it => it.value === 'all')
  }
  return result
}

function displayAllTag(role, optionsWithoutAll, isOperator = false) {
  if (['admin', 'root', 'owner'].includes(role)) {
    if (!optionsWithoutAll) {
      if (isOperator) return [{ _id: 'all', name: I18n.t('dashboard_all-plural-female'), operator: 'all' }]
      return [{ _id: 'all', name: I18n.t('dashboard_all-plural-female'), brand: 'all' }]
    }
  }

  return []
}

const Index = () => {
  const user = useSelector((store) => (store.user))

  const [headers, setHeaders] = React.useState(_headers)
  const [brands, setBrands] = React.useState([])
  const [delegations, setDelegations] = React.useState([])
  const [brandsDetail, setBrandsDetail] = React.useState([])
  const [delegationsDetail, setDelegationsDetail] = React.useState([])
  const [categories, setCategories] = React.useState([])

  const [operators, setOperators] = React.useState([])
  const [currentOperators] = React.useState([])
  const [operatorOptions, setOperatorOptions] = React.useState([])
  const [selectedOperators, setSelectedOperators] = React.useState([])
  const [displayAllValues] = React.useState(true)

  const [errorMessageDetail, setErrorMessageDetail] = React.useState(false)

  const [order, setOrder] = React.useState({ value: 'asc', label: I18n.t('order_by_az') })
  const [isOpenModal, setIsOpenModal] = React.useState(false)
  const [isOpenModalDelete, setIsOpenModalDelete] = React.useState(false)
  const [valuesToEdit, setValuesToEdit] = React.useState({})
  const [categoryToRemove, setCategoryToRemove] = React.useState({})
  const [removing, setRemoving] = React.useState(false)
  const [isSubmitting, setIsSubmitting] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState(false)
  const [isEdit, setIsEdit] = React.useState(false)
  const [inRequest, setInRequest] = React.useState(false)


  const [filterByOperator, setFilterByOperator] = React.useState(false)

  React.useEffect(() => {
    if (!isOpenModal && brands.length > 0 && delegations.length > 0) {
      getCategories(brands, delegations)
    } else {
      setCategories([])
    }

  }, [brands, delegations])

  React.useEffect(() => {
    if (!isOpenModal && filterByOperator && selectedOperators.length) {
      if (selectedOperators.some(o => o.value === 'all')) getCategoriesByOperators(operatorOptions)
      else getCategoriesByOperators(selectedOperators)
    } else {
      setCategories([])
    }
  }, [selectedOperators])

  React.useEffect(() => {
    if (!isOpenModal && filterByOperator)
      setOperatorOptions(getObjectValues(operators, null, true))
  }, [operators])

  React.useEffect(() => {
    if (!isOpenModal && filterByOperator)
      setSelectedOperators(orderItems(currentOperators || [], operators))
  }, [operatorOptions])

  React.useEffect(() => {
    if (!isOpenModal) setValuesToEdit({})
  }, [isOpenModal])

  React.useEffect(() => {
    if (!isOpenModal && filterByOperator) {
      categoriesApi.filters()
        .then(({ data: { operators: _operators } }) => {
          setOperators((displayAllValues ? [...displayAllTag(user.role, false, true)] : []).concat(_operators))
        })
        .catch(console.error)
    }
  }, [filterByOperator])

  const orderBy = (_header) => {
    _header.filter = _header.filter ? (_header.filter === 'asc' ? 'desc' : 'asc') : 'asc'
    const _headers = _.clone(headers)
    _headers.forEach(it => {
      it.filter = it.value === _header.value ? _header.filter : null
    })

    setHeaders(_headers)
    orderBody(categories, _header)
  }

  const orderBody = (_categoriesList = categories, _header) => {
    const _categories = _.cloneDeep(_categoriesList)
    setCategories(_categories.sort((a, b) => _header.filter === 'asc' ? a.name.localeCompare(b.name) : a.name.localeCompare(b.name) * -1))
  }

  const onChange = (value, type) => {
    setErrorMessage(false)
    if (type === 'brand') {
      if (!isOpenModal) {
        setBrands(value)
        setDelegations([])
      }
      else {
        setBrandsDetail(value)
        setDelegationsDetail([])
      }
    }
    else if (type === 'delegation') {
      if (!isOpenModal) setDelegations(value)
      else setDelegationsDetail(value)
    }
    else if (type === 'order') {
      setOrder(value)
      setCategories(categories.sort((a, b) => value.value === 'asc' ? a.name.localeCompare(b.name) : a.name.localeCompare(b.name) * -1))
    }
    else if (type === 'operators') {
      setSelectedOperators(orderItems(value || [], operators))
    }
    else if (type === 'toggle') {
      if (isOpenModal) {
        setBrandsDetail([])
        setDelegationsDetail([])
      } else {
        setFilterByOperator(value)
        setCategories([])
        setBrands([])
        setDelegations([])
        setSelectedOperators([])
      }
    }
  }

  const getCategoriesByOperators = (operators) => {
    setErrorMessage(false)
    setInRequest(true)
    if (!operators.length) setErrorMessage(I18n.t('resources_not_data'))

    let operatorsToSend = []
    operators.forEach(operator => {
      if (operator.value !== 'all') operatorsToSend.push(operator.value)
    })

    if (operatorsToSend.length) {
      categoriesApi.getByOperators(operatorsToSend, order.value)
        .then(({ data }) => {
          if (!data.length) setErrorMessage(I18n.t('resources_not_data'))
          setCategories(data.sort((a, b) => order.value === 'asc' ? a.name.localeCompare(b.name) : a.name.localeCompare(b.name) * -1))
          setInRequest(false)
        })
        .catch((error) => {
          setInRequest(false)
          console.error(error)
        })
    } else {
      setErrorMessage(I18n.t('resources_not_data'))
      setInRequest(false)
    }
  }

  const getCategories = (_brands, _delegations) => {
    setErrorMessage(false)
    setInRequest(true)
    let brandsToSend = []
    let delegationsToSend = []
    _brands.forEach(it => {
      if (it.value !== 'all')
        brandsToSend.push(it.value)
    })
    _delegations.forEach(it => {
      if (it.value !== 'all')
        delegationsToSend.push(it.value)
    })
    if (_brands.length > 0 && _delegations.length > 0) {
      categoriesApi.get(brandsToSend, delegationsToSend, order.value).then(result => {
        if (result.data.length === 0) {
          setErrorMessage(I18n.t('resources_not_data'))
        }
        setCategories(result.data.sort((a, b) => order.value === 'asc' ? a.name.localeCompare(b.name) : a.name.localeCompare(b.name) * -1))
        setInRequest(false)
      }).catch((error) => {
        setInRequest(false)
        console.error(error)
      })
    } else setInRequest(false)
  }

  const save = (category) => {
    setIsSubmitting(true)

    const data = {
      _id: category._id,
      name: category.name,
      color: category.color,
      withOperator: category.forOperator
    }

    if (!category.forOperator) {
      const brandsToSave = []
      category.brands.forEach(it => {
        const id = it.value || it._id
        if (id !== 'all') {
          brandsToSave.push({ _id: id, name: it.label || it.name })
        }
      })
      data.brands = brandsToSave
      const delegationsToSave = []
      category.delegations.forEach(it => {
        const id = it.value || it._id
        if (id !== 'all') {
          delegationsToSave.push({ _id: id, name: it.label || it.name, brand: it.brand || it.data.brand || it.data.data.brand })
        }
      })
      data.delegations = delegationsToSave
    }

    if (data._id) {
      categoriesApi.put(data._id, data).then(result => {
        setIsOpenModal(false)
        setIsSubmitting(false)
        if (!category.forOperator) getCategories(brands, delegations)
        else getCategoriesByOperators([{ value: category.operator }])
      }).catch(error => {
        if (error.response.data.type === 'error_name_duplicate') setErrorMessageDetail(true)
        setIsSubmitting(false)
        setErrorMessageDetail(false)
        console.error(error)
      })
    } else {
      categoriesApi.post(data).then((result) => {
        setIsOpenModal(false)
        setIsSubmitting(false)

        if (!category.forOperator) getCategories(brands, delegations)
        else getCategoriesByOperators([{ value: result.data.operator }])
      }).catch(error => {
        if (error.response.data.type === 'error_name_duplicate') setErrorMessageDetail(true)
        setErrorMessageDetail(false)
        setIsSubmitting(false)
        console.error(error)
      })
    }
  }

  const openModalToEdit = (values) => {
    setIsEdit(true)
    setValuesToEdit(values)
    setIsOpenModal(true)
  }

  const deleteCategory = (values) => {
    setRemoving(true)
    categoriesApi.remove(values._id).then(result => {
      setIsOpenModalDelete(false)
      setCategoryToRemove({})
      setRemoving(false)
      if (!values.operator) getCategories(brands, delegations)
      else getCategoriesByOperators([{ value: values.operator }])
    }).catch(error => {
      setIsOpenModalDelete(false)
      setCategoryToRemove({})
      setRemoving(false)
      console.error(error)
    })
  }

  return (
    <div className='animated fadeIn'>
      <Container fluid className='py-5 categories-configuration'>
        <div className='wrapper-categories section mb-4'>
          <h1>{I18n.t('dashboard_labels')}</h1>
          <legend dangerouslySetInnerHTML={{ __html: I18n.t('labels_subtitle') }} />

          <div className='seccion-1'>
            <div className='switch-section'>
              <ReactSwitch
                onChange={(value) => onChange(value, 'toggle')}
                checked={filterByOperator}
                onColor='#E87721'
                uncheckedIcon={false}
                checkedIcon={false}
                onHandleColor='#fff'
                width={50}
                height={25}
                className={'activated'}
              />
              <span>{I18n.t('dashboard_show-operator-labels')}</span>
            </div>
            {
              !filterByOperator && <BrandsAndDelegations
                onChangeBrands={(value) => onChange(value, 'brand')}
                currentBrands={brands || []}
                onChangeDelegations={(value) => onChange(value, 'delegation')}
                currentDelegations={delegations || []}
                displayAllValues={displayAllValues}
                classNameWrapper={'animated fadeIn'}
              />
            }
            {
              filterByOperator && <div className='wrapper-mode-1 animated fadeIn'>
                <div className='seccion-mode-1'>
                  <label htmlFor={'operators'}>{I18n.t('dashboard_operators')}</label>
                  <SelectWithLabel
                    name='operators'
                    key='operators'
                    options={operatorOptions}
                    value={selectedOperators}
                    selectedValues={selectedOperators || currentOperators}
                    onChange={(value) => onChange(value?.some(v => v.value === "all") ? operatorOptions : value, 'operators')}
                    multi={true}
                    placeholder={I18n.t('dashboard_filter-by-operator')}
                    isClearable
                  />
                </div>
              </div>
            }
          </div>
          <div className='wrapper-error animated fadeIn'>
            <small className='error'>{errorMessage}</small>
          </div>

          <div className='seccion-2'>
            <CategoriesList
              headers={headers}
              orderBy={(headers) => orderBy(headers)}
              brands={brands}
              delegations={delegations}
              categories={categories}
              edit={openModalToEdit}
              remove={(values) => { setIsOpenModalDelete(true); setCategoryToRemove(values) }}
              filterByOperators={filterByOperator}
              inRequest={inRequest}
            />
          </div>
          <div className={`add-category`} onClick={() => { setIsOpenModal(true); setBrandsDetail([]); setDelegationsDetail([]); setIsEdit(false) }}>
            <img src={getStaticImage('/icons/orange-brand/icon-add.svg')} alt='Add category' />
            <span>{I18n.t('dashboard_add-label')}</span>
          </div>

          {isOpenModal && <CategoriesDetail
            brands={brandsDetail}
            onChangeBrands={(value) => onChange(value, 'brand')}
            delegations={delegationsDetail}
            onChangeDelegations={(value) => onChange(value, 'delegation')}
            onChangeToggle={(value) => onChange(value, 'toggle')}
            categories={categories}
            isOpen={isOpenModal}
            toggle={() => { setIsOpenModal(!isOpenModal); setIsEdit(false) }}
            save={save}
            valuesToEdit={valuesToEdit}
            isSubmitting={isSubmitting}
            displayAllValues={displayAllValues}
            errorMessage={errorMessageDetail}
            isEdit={isEdit}
          />}

          <ModalDelete
            isOpen={isOpenModalDelete}
            toggle={() => setIsOpenModalDelete(!isOpenModalDelete)}
            header={I18n.t('dashboard_delete-label')}
            text1={I18n.t('labels_remove_label_title')}
            text2={I18n.t('dashboard_action-cannot-reversed')}
            event={() => deleteCategory(categoryToRemove)}
            isSubmitting={removing}
          />

        </div>
      </Container>
    </div>
  )
}

export default Index